import { createStore } from 'vuex';

import auth from './auth/';
import resumes from './resumes';
import popup from './popup';
import organization from './organization';
import toaster from './toaster';
import aiAssistant from './ai-assistant';

export default createStore({
  modules: {
    auth,
    resumes,
    popup,
    organization,
    toaster,
    aiAssistant,
  },
  strict: false,
});
